import { useQuery } from "@tanstack/react-query";
import { automationsService } from "services/admin/automationsService";

export const useGetAutomations = () => {
    return useQuery({
        queryKey: ['getAutomations'],
        queryFn: async () => {
            const response = await automationsService.getAutomations()
            return response.rows
        },
        select: (data) => data,
    })
}